var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.disableTransitions ? '' : 'mc-zoom-in-center'}},[_c('div',{staticClass:"mc-tag",class:[
      _vm.type ? 'mc-tag--' + _vm.type : '',
      _vm.tagSize && ("mc-tag--" + _vm.tagSize),
      {'is-hit': _vm.hit}
    ],style:({backgroundColor: _vm.color}),on:{"click":_vm.handleClick}},[((typeof _vm.prepend === 'number' || typeof _vm.prepend === 'string'))?_c('span',{staticClass:"mc-tag__prepend",domProps:{"textContent":_vm._s(_vm.prepend)}}):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.closable)?_c('i',{staticClass:"mc-tag__close fa fa-close-custom",on:{"click":function($event){$event.stopPropagation();_vm.handleClose($event)}}}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


// WEBPACK FOOTER //
// ./src/components/tag.vue